import { render, staticRenderFns } from "./editUsersOpeningBalance.vue?vue&type=template&id=f872524c"
import script from "./editUsersOpeningBalance.vue?vue&type=script&lang=js"
export * from "./editUsersOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./editUsersOpeningBalance.vue?vue&type=style&index=0&id=f872524c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports